import { useEffect, type RefObject } from "react";

/**
 * Calls `onOutsideClick` when a mousedown occurs outside of the ref element.
 * Only active when `isActive` is true.
 */
export function useOutsideClick(
  ref: RefObject<HTMLElement | null>,
  onOutsideClick: () => void,
  isActive: boolean,
) {
  useEffect(() => {
    if (!isActive) return;
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onOutsideClick();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [ref, onOutsideClick, isActive]);
}
